import { NavigationItemType } from '@data/types';
import useStore from '@store/store';
import classNames from 'classnames';
import React from 'react';

interface Props extends NavigationItemType {
  setShowMobileNavigation: (showMobileNavigation: boolean) => void;
}

const NavigationOptionItem: React.FC<Props> = ({
  title,
  href,
  setShowMobileNavigation,
}) => {
  const { page, setPage } = useStore();
  const santisedTitle: string = title.toLowerCase().replace(' ', '_');

  return (
    <li
      className={classNames('text-blue hover:text-red', {
        '!text-red': page === santisedTitle,
      })}
    >
      <a
        href={href}
        onClick={(event) => {
          event.preventDefault();
          setShowMobileNavigation(false);
          window.scrollTo(0, 0);
          return setPage(santisedTitle);
        }}
        className={classNames(
          'text-blue hover:text-red text-sm font-lightNormal block py-2 capitalize',
          {
            '!text-red': page === santisedTitle,
          }
        )}
      >
        {title ? title.toLowerCase().replace('_', ' ') : ''}
      </a>
    </li>
  );
};

export default NavigationOptionItem;
